const NotificationBar = ({ notifications }) => {
  return notifications?.length > 0 ? (
    <div className="ticker-wrapper px-2 overflow-hidden">
      <div className="ticker-content d-inline-block">
        {notifications.map((notification, index) => (
          <span key={index} className="ticker-item text-dark fs-15 mx-4">
            🔔 {notification?.content}
          </span>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default NotificationBar;
